var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, customElement, html, LitElement, property } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { escapeHtml } from '../helpers/escape';
import './product-tile-compact';
import './loading-spinner';
import i18n from 'roddeh-i18n';
import { ProductSearchUrlBuilder } from '../services/product-search-request';
let TcAutocomplete = class TcAutocomplete extends LitElement {
    constructor() {
        super();
        this.phrase = '';
        this.correctedPhrase = '';
        this.searchUrl = null;
        this.open = false;
        this.hints = {
            phrase: { suggestions: [], meta: null },
            category: { suggestions: [], meta: null },
            product: { suggestions: [], meta: null },
        };
        this.loading = false;
        this.lastPhrases = [];
        this.suggestedPhrasesEnabled = true;
        this.productSearchRequest = null;
        if (typeof window.__STATE__ !== 'undefined') {
            this.suggestedPhrasesEnabled = window.__STATE__.functions.tcai_suggested_phrases_enabled;
        }
    }
    static get styles() {
        return css `
            :host {
                position: absolute;
                left: 0;
                right: 0;
                z-index: 10;
                top: 0;
            }
            .container {
                display: none;
                height: 100%;
                background-color: #fff;
                box-shadow: 0 0px 10px 0 rgba(0, 0, 0, 0.1);
                color: var(--primary-font-color);
            }
            .container .hints-wrapper {
                padding: 0 0 2rem 0;
                padding-left: calc((100% - 1248px) / 2);
                padding-right: calc((100% - 1248px) / 2);
            }

            .container .hints-no-result {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                flex-direction: column;
                padding-top: 1rem;
            }

            .container .hints-wrapper-corrected-phrase {
                padding: 0 0 2rem 0;
                text-align: center;
                box-shadow: inset 0 0px 10px 0 rgba(0, 0, 0, 0.1);
            }

            .container .hints-no-result h3 {
                font-size: 1rem;
            }

            .container .last-phrases-wrapper {
                padding: 0.75rem 0;
                display: grid;
                grid-template-columns: auto 1fr;
                grid-column-gap: 1rem;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                padding-left: calc((100% - 1248px) / 2);
                padding-right: calc((100% - 1248px) / 2);
            }
            .container .last-phrases-wrapper h3 {
                font-size: 1rem;
            }
            .container .last-phrases-wrapper .last-phrases {
                display: flex;
                column-gap: 2rem;
            }
            .container .hints {
                display: grid;
                grid-template-columns: fit-content(250px) minmax(0px, 4fr);
                grid-gap: 1em;
            }

            .container .products .products-header a,
            .container .last-phrases-wrapper .last-phrases a,
            .container .hints .facets a,
            .container .hints .phrase a {
                display: block;
                padding-bottom: 0.5rem;
                color: var(--color-primary);
                text-decoration: none;
                transition: color 100ms ease-in-out;
                font-weight: bold;
                cursor: pointer;
            }

            .container .products .products-header a,
            .container .last-phrases-wrapper .last-phrases a {
                padding: 0;
            }

            .container .last-phrases-wrapper .last-phrases a {
                display: flex;
                align-items: center;
            }

            .container .last-phrases-wrapper .last-phrases a:hover,
            .container .hints .facets a:hover,
            .container .hints .phrase a:hover {
                color: var(--color-primary-dark);
            }
            .container .products .tiles {
                display: grid;
                grid-template-columns: repeat(2, minmax(0px, 1fr));
                grid-gap: 1rem;
            }
            .container .products .products-header {
                display: flex;
                width: 100%;
                justify-content: space-between;
                align-items: center;
            }

            .container .hints .facets a .facet-details {
                font-weight: normal;
                font-size: 0.75em;
                color: #a9a9a9;
            }

            .container .hints .facets a:hover .facet-details {
                font-size: 0.75em;
                color: #a9a9a9;
            }

            .container h3 {
                text-transform: uppercase;
            }

            .container h3 .count {
                font-weight: normal;
            }

            @media (max-width: 1262px) {
                .container {
                    padding-left: 0.35em;
                    padding-right: 0.35em;
                }

                .container .products .tiles {
                    grid-template-columns: repeat(2, minmax(0px, 1fr));
                }
            }

            @media (max-width: 960px) {
                .container .products .tiles {
                    grid-template-columns: repeat(1, minmax(0px, 1fr));
                }
            }

            @media (max-width: 820px) {
                .container {
                    height: calc(100vh - 120px);
                    overflow: auto;
                }

                .container .hints .products {
                    padding-bottom: 100px;
                }

                .container .hints {
                    grid-template-columns: minmax(0px, 1fr) minmax(0px, 2fr);
                }

                .container .last-phrases-wrapper {
                    grid-template-columns: 1fr;
                }
                .container .hints-no-result {
                    justify-content: initial;
                }
            }

            @media (max-width: 530px) {
                .container .hints {
                    grid-template-columns: 1fr;
                }
                .container .phrases {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }

                .container .last-phrases-wrapper .last-phrases {
                    display: flex;
                    row-gap: 1rem;
                    align-items: flex-start;
                    flex-direction: column;
                }
            }

            @media (max-width: 420px) {
                .container .phrases {
                    grid-template-columns: 1fr;
                }
            }
        `;
    }
    render() {
        return html `
            <div>
                ${this.phrase === '' && this.lastPhrases.length > 0
            ? html `
                          <div class="container full-width" style="${this.open ? 'display:block;' : ''}">
                              <div class="last-phrases-wrapper">
                                  <h3>${i18n('Your last searches:')}</h3>
                                  <div class="last-phrases">
                                      ${this.lastPhrases.map((phrase) => {
                let phraseShort = phrase;
                if (phrase.length > 22) {
                    phraseShort = phrase.substring(0, 22) + '...';
                }
                return html `<a href="${this.getSearchUrl(phrase)}">${phraseShort}</a>`;
            })}
                                  </div>
                              </div>
                          </div>
                      `
            : ``}
                ${this.phrase !== '' &&
            this.hints.product.suggestions.length === 0 &&
            this.hints.phrase.suggestions.length === 0
            ? html `
                    <div class="container full-width" style="${this.open ? 'display:block;' : ''}">
                        <div class="hints-wrapper">
                            <div class="hints-no-result">
                                <h3>${i18n('No hints found')}</h3>
                                <div class="no-result-description">
                                    ${i18n('Try to change your search phrase')}
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>`
            : ``}
                ${this.phrase !== '' &&
            (this.hints.product.suggestions.length > 0 || this.hints.phrase.suggestions.length > 0)
            ? html `
                    <div class="container full-width" style="${this.open ? 'display:block;' : ''}">
                        ${this.correctedPhrase !== ''
                ? html ` <div class="hints-wrapper-corrected-phrase">
                                      <div class="hints-no-result">
                                          <h3>${unsafeHTML(this.formatPhrase(i18n('hints_no_result')))}</h3>
                                          <div class="no-result-description">
                                              ${unsafeHTML(this.formatPhrase(i18n('hints_no_result_description')))}
                                          </div>
                                      </div>
                                  </div>`
                : ``}
                        <div class="hints-wrapper">
                            <div class="hints">
                                <div class="phrases">
                                    ${this.hints.product.meta &&
                this.hints.product.meta.facets &&
                this.hints.product.meta.facets.categories_facets
                ? html `
                                                  <div class="phrase-in-category">
                                                      <h3>
                                                          ${i18n('Search in category')}
                                                          <span class="count"
                                                              >(${this.hints.product.meta.facets.categories_facets
                    .length})</span
                                                          >
                                                      </h3>
                                                      <div class="facets">
                                                          ${this.hints.product.meta.facets.categories_facets.map((facet) => html `
                                                                  <div class="facet">
                                                                      <a
                                                                          href="${this.getTransformedUrl(facet.navigation.alternate_url)}"
                                                                      >
                                                                          ${this.correctedPhrase !== ''
                    ? this.correctedPhrase
                    : this.phrase}
                                                                          <div class="facet-details">
                                                                              ${i18n('in category')}
                                                                              <strong>${facet.value}</strong>
                                                                              (${facet.count})
                                                                          </div>
                                                                      </a>
                                                                  </div>
                                                              `)}
                                                      </div>
                                                  </div>
                                              `
                : ``}

                                    ${this.suggestedPhrasesEnabled && this.hints.phrase.suggestions.length > 0
                ? html ` <div class="suggested-phrases">
                                                  <h3>${i18n('Suggested phrases')}</h3>
                                                  ${this.hints.phrase.suggestions.map((hint) => html `
                                                          <div class="phrase">
                                                              <a @click="${this.setSuggestedPhrase}">${hint.value}</a>
                                                          </div>
                                                      `)}
                                              </div>`
                : ``}
                                </div>
                                ${this.hints.product.suggestions.length > 0
                ? html `
                                              <div class="products">
                                                  <div class="products-header">
                                                      <h3>
                                                          ${i18n('Products')}
                                                          ${this.hints.product.meta && this.hints.product.meta.total > 0
                    ? html ` <span class="count"
                                                                    >(${this.hints.product.meta.total})</span
                                                                >`
                    : ``}
                                                      </h3>
                                                      <a href="${this.getSearchUrl(this.phrase)}">
                                                          ${i18n('Show all results')}
                                                      </a>
                                                  </div>

                                                  <div class="tiles">
                                                      ${this.hints.product.suggestions.map((hint) => html `
                                                              <product-tile-compact
                                                                  .logUrl="${this.getLogUrl(hint.data.log_url, [
                    'hints_product_tile',
                ])}"
                                                                  .product=${hint.data.product}
                                                              ></product-tile-compact>
                                                          `)}
                                                  </div>
                                              </div>
                                          `
                : ``}
                            </div>
                        </div>
                    </div>
                    </div>`
            : ``}
            </div>
        `;
    }
    formatPhrase(phrase) {
        return phrase
            .replace('{phrase}', escapeHtml(this.phrase))
            .replace('{corrected_phase}', escapeHtml(this.correctedPhrase));
    }
    getTransformedUrl(urlString) {
        const url = new URL(urlString, window.location.toString());
        return ProductSearchUrlBuilder.buildUrl(url, null, this.productSearchRequest).toString();
    }
    getSearchUrl(phrase = null) {
        if (this.searchUrl === null) {
            return '';
        }
        const stringUrl = this.searchUrl.toString();
        const url = new URL(stringUrl);
        const params = {};
        if (phrase) {
            params['q'] = phrase;
        }
        return ProductSearchUrlBuilder.buildUrl(url, params, this.productSearchRequest).toString();
    }
    getLogUrl(logUrl, tags) {
        if (logUrl === null) {
            return null;
        }
        const url = new URL(logUrl);
        url.searchParams.append('tags', JSON.stringify(tags));
        return url.toString();
    }
    setSuggestedPhrase(event) {
        const target = event.target;
        if (!(target instanceof HTMLAnchorElement)) {
            return;
        }
        const changePhrase = new CustomEvent('change-phrase', {
            detail: target.textContent || '',
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(changePhrase);
    }
};
__decorate([
    property({ type: String })
], TcAutocomplete.prototype, "phrase", void 0);
__decorate([
    property({ type: String })
], TcAutocomplete.prototype, "correctedPhrase", void 0);
__decorate([
    property({ type: URL })
], TcAutocomplete.prototype, "searchUrl", void 0);
__decorate([
    property({ type: Boolean })
], TcAutocomplete.prototype, "open", void 0);
__decorate([
    property({ type: Object })
], TcAutocomplete.prototype, "hints", void 0);
__decorate([
    property({ type: Boolean })
], TcAutocomplete.prototype, "loading", void 0);
__decorate([
    property({ type: Array })
], TcAutocomplete.prototype, "lastPhrases", void 0);
TcAutocomplete = __decorate([
    customElement('tc-autocomplete')
], TcAutocomplete);
export default TcAutocomplete;
